// extracted by mini-css-extract-plugin
export default {"bottomSlide":"index_bottomSlide_TwNXL","activityBox":"index_activityBox_6nXzi","activityImage":"index_activityImage_-48c0"};